var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pc-items"},[(_vm.payments.length)?_c('ul',{staticClass:"pc-items-list"},_vm._l((_vm.payments),function(payment){return _c('pc-item',{key:payment.id,attrs:{"payment":payment}})}),1):_c('div',{staticClass:"ms-nodata ms-help"},[_vm._v("\n    Платежи отсутствуют\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }